import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { LayoutStack } from '../../../components/layouts/LayoutStack';
import { headlessLinkProps } from '../../../components/TextLink';
import { useIsMounted } from '../../../hooks';
import { DefaultLink, LinkItem } from '../../shared';
import styles from './TaxReceiptHint.module.css';
function displayTaxReceiptHint() {
  const now = new Date();
  return now.getMonth() > 8 || now.getMonth() < 1; // JS months are 0-indexed (9 = October, 0 = January)
}
function taxReceiptHintRelevantYear() {
  const now = new Date();
  let year = now.getFullYear();
  if (now.getMonth() < 9) {
    // If before October
    year -= 1;
  }
  return year;
}
function useTaxReceiptHint() {
  const $ = _c(4);
  const mounted = useIsMounted();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = taxReceiptHintRelevantYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const year = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = displayTaxReceiptHint();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShow = t1;
  const t2 = shouldShow && mounted;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      showHint: t2,
      year
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function TaxReceiptHint(t0) {
  const $ = _c(19);
  const {
    children,
    href,
    label,
    Link: t1
  } = t0;
  const Link = t1 === undefined ? DefaultLink : t1;
  const {
    className
  } = headlessLinkProps({
    kind: "secondary"
  });
  const {
    showHint,
    year
  } = useTaxReceiptHint();
  if (!showHint) {
    return null;
  }
  const T0 = LayoutStack;
  const t2 = "none";
  const t3 = styles;
  const t4 = styles;
  let t5;
  if ($[0] !== children || $[1] !== year) {
    t5 = children.replace("0000", year.toString()).replace("0001", (year + 1).toString());
    $[0] = children;
    $[1] = year;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = "\u2002";
  const T1 = LinkItem;
  const t7 = classNames(className, styles.learnMoreLink);
  let t8;
  if ($[3] !== Link || $[4] !== T1 || $[5] !== href || $[6] !== label || $[7] !== t7) {
    t8 = <T1 Link={Link} href={href} className={t7} data-axe-expect="color-contrast">{label}</T1>;
    $[3] = Link;
    $[4] = T1;
    $[5] = href;
    $[6] = label;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t5 || $[10] !== t8) {
    t9 = <p>{t5}{t6}{t8}</p>;
    $[9] = t5;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t4.content || $[13] !== t9) {
    t10 = <div className={t4.content}>{t9}</div>;
    $[12] = t4.content;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== T0 || $[16] !== t10 || $[17] !== t3.taxReceiptHint) {
    t11 = <T0 space={t2} className={t3.taxReceiptHint}>{t10}</T0>;
    $[15] = T0;
    $[16] = t10;
    $[17] = t3.taxReceiptHint;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
}
export default TaxReceiptHint;